import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from '../_services/token-storage.service';
import { RoleService } from '../_services/role.service';
import { finalize, switchMap } from 'rxjs/operators';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  userRoles: string[] = [];
  readonly allRoles: string[] = [
    'ROLE_SUPER_ADMIN',
    'ROLE_ADMIN',
    'ROLE_MONITOR',
    'ROLE_READER',
    'ROLE_STUDENT'
  ];

  editRoles = false;
  loadingRole: string | null = null;
  navMobile = false;

  constructor(
    private token: TokenStorageService,
    private roleService: RoleService
  ) {}

  ngOnInit(): void {
    this.checkWindowSizeChange();
    this.loadUserRoles();
  }

  /* ========================
     UTILS
     ======================== */

  private myProfileId(): string | undefined {
    return this.token.getUser()?.id;
  }

  toggleEditRoles(): void {
    this.editRoles = !this.editRoles;
  }

  get availableRoles(): string[] {
    return this.allRoles.filter(role => !this.userRoles.includes(role));
  }

  /* ========================
     LOAD ROLES
     ======================== */

  loadUserRoles(): void {
    const userId = this.myProfileId();
    if (!userId) { return; }

    this.roleService.getUserRoles(userId).subscribe({
      next: (roles: string[]) => {
        this.userRoles = roles ?? [];
      },
      error: err => console.error('Erreur chargement rôles', err)
    });
  }

  /* ========================
     ADD ROLE
     ======================== */

  addRole(role: string): void {
    const userId = this.myProfileId();
    if (!userId || this.loadingRole) { return; }

    this.loadingRole = role;

    this.roleService.addRole(userId, role).pipe(
      switchMap(() => this.roleService.getUserRoles(userId)),
      finalize(() => this.loadingRole = null)
    ).subscribe({
      next: (roles: string[]) => {
        this.userRoles = roles ?? [];
      },
      error: err => {
        console.error('Erreur ajout rôle', err);
        this.loadUserRoles();
      }
    });
  }

  /* ========================
     REMOVE ROLE
     ======================== */

  removeRole(role: string): void {
    const userId = this.myProfileId();
    if (!userId || this.loadingRole) { return; }

    this.loadingRole = role;

    this.roleService.removeRole(userId, role).pipe(
      switchMap(() => this.roleService.getUserRoles(userId)),
      finalize(() => this.loadingRole = null)
    ).subscribe({
      next: (roles: string[]) => {
        this.userRoles = roles ?? [];
      },
      error: err => {
        console.error('Erreur suppression rôle', err);
        this.loadUserRoles();
      }
    });
  }

  /* ========================
     UI
     ======================== */

  checkWindowSizeChange(): void {
    this.navMobile = window.innerWidth < 577;
  }
}
